<div class="modal-header">
	<h3 class="modal-title">{{ contentConfig.textsKey + 'Title' | translate: contentConfig.titleParams }}</h3>
	@if (!contentConfig.hideCloseBtn) {
		<button type="button" class="close" data-cy="CloseModal" (click)="dismiss()">
			<i class="far fa-times"></i>
		</button>
	}
</div>
<div class="modal-body" [formGroup]="form">
	<p [innerHTML]="(contentConfig.questionKey || contentConfig.textsKey) + 'Question' | translate: contentConfig.questionParams | safe:'html'"></p>
	@if (contentConfig.withComment) {
		<div class="form-group">
			<label class="form-label" for="field-comment" translate="DataList.Columns.Comment"></label>
			<textarea id="field-comment" class="form-control form-control-alt" formControlName="comment" rows="2"></textarea>
			<form-control-feedback [field]="form.get('comment')"/>
		</div>
	}
</div>
<div class="modal-footer modal-footer-reverse">
	@if (!contentConfig.hideConfirmBtn) {
		<button type="button" class="btn btn-primary" ngbAutofocus data-cy="ConfirmYes"
		[disabled]="contentConfig.disableConfirmBtn || (contentConfig.withComment && form.get('comment')?.invalid)"
		(click)="submit()">{{ (contentConfig.confirmBtnText || 'CommonTexts.Yes') | translate }}</button>
	}
	@if (!contentConfig.hideCancelBtn) {
		<button type="button" class="btn btn-default" data-cy="ConfirmNo"
		(click)="dismiss()">{{ (contentConfig.cancelBtnText || 'CommonTexts.No') | translate }}</button>
	}
</div>
